import { AgmCoreModule } from '@agm/core';
import { AgmJsMarkerClustererModule } from '@agm/js-marker-clusterer';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TreeModule } from 'angular-tree-component';
import { ChartsModule } from 'ng2-charts';
import { Ng2GoogleChartsModule } from 'ng2-google-charts';
import { TagInputModule } from 'ngx-chips';
import { ImageCropperModule } from 'ngx-image-cropper';
import { NgxUploaderModule } from 'ngx-uploader';
// Views
import {
  DeviceFilterPipe,
  FileSizePipe,
  MaterialModule,
  MsTimePipe,
  PrimeModule,
  SpeedTransferPipe,
  TimeElapsedPipe,
  TimeRemainingPipe,
  UserFilterPipe,
} from './helpers';
import { ContentFilterPipe } from './helpers/content-filter.pipe';
// Services
import {
  ActivationService, AnalyticService, ApplicationService,
  AuditService,
  ContentService,
  DeviceService,
  DistributionService,
  GroupService,
  RemoteConfigService,
  SocketService, StructuredService, SyncService,
  SyncthingService,
  UserService,
} from './services';
import { HttpInterceptor } from './services/http-error.interceptor';
import {
  ConfirmDialog,
  ContentCardComponent,
  ContentCardSmallComponent,
  ContentDetailCardComponent,
  ContentInfoDialog,
  ConvertToStructuredDialog,
  DeviceCardComponent,
  DeviceDetailCardComponent,
  DeviceSyncOtionsModal, DeviceTimelineComponent, EditContentDialog,
  EditThumbnailDialog,
  ExportCsvDialog,
  ManageCollaboratorsDialog,
  ManageContentsModal, ManageDevicesModal, ManageUsersModal,
  MessageDialog,
  SearchBarComponent,
  UserCardComponent,
} from './views';
import { AnalyticComponent, ProxyStatisticsComponent } from './views/analytic';

@NgModule({
  declarations: [
    UserCardComponent,
    DeviceTimelineComponent,
    SearchBarComponent,
    ConfirmDialog,
    EditContentDialog,
    EditThumbnailDialog,
    ExportCsvDialog,
    ManageCollaboratorsDialog,
    ContentInfoDialog,
    ConvertToStructuredDialog,
    MessageDialog,
    DeviceCardComponent,
    DeviceDetailCardComponent,
    AnalyticComponent,
    ProxyStatisticsComponent,
    ContentCardComponent,
    ContentCardSmallComponent,
    ContentDetailCardComponent,
    TimeElapsedPipe,
    TimeRemainingPipe,
    MsTimePipe,
    UserFilterPipe,
    DeviceFilterPipe,
    ContentFilterPipe,
    FileSizePipe,
    SpeedTransferPipe,
    ManageDevicesModal,
    ManageUsersModal,
    ManageContentsModal,
    DeviceSyncOtionsModal,
  ],
  entryComponents: [ConfirmDialog, EditContentDialog, EditThumbnailDialog, ExportCsvDialog, ManageCollaboratorsDialog, MessageDialog, ContentInfoDialog, ConvertToStructuredDialog],
  exports: [
    CommonModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TreeModule,
    TagInputModule,
    UserCardComponent,
    DeviceTimelineComponent,
    SearchBarComponent,
    DeviceCardComponent,
    DeviceDetailCardComponent,
    ContentCardComponent,
    AnalyticComponent,
    ProxyStatisticsComponent,
    ConfirmDialog,
    EditContentDialog,
    EditThumbnailDialog,

    ExportCsvDialog,
    ManageCollaboratorsDialog,
    MessageDialog,
    ContentInfoDialog,
    ConvertToStructuredDialog,
    ContentCardSmallComponent,
    ContentDetailCardComponent,
    TimeElapsedPipe,
    TimeRemainingPipe,
    MsTimePipe,
    UserFilterPipe,
    DeviceFilterPipe,
    ContentFilterPipe,
    FileSizePipe,
    SpeedTransferPipe,
    ManageDevicesModal,
    ManageUsersModal,
    ManageContentsModal,
    DeviceSyncOtionsModal,
    NgbModule,
    MaterialModule,
    PrimeModule,
    AgmCoreModule,
    AgmJsMarkerClustererModule,
    Ng2GoogleChartsModule,
    ChartsModule,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    RouterModule,
    TreeModule,
    TagInputModule,
    NgbModule.forRoot(),
    MaterialModule,
    PrimeModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBXvx-qtGI_-5BcZuAl4w2wM7TQ_xH4z-8',
      libraries: ['places'],
    }),
    AgmJsMarkerClustererModule,
    NgxUploaderModule,
    Ng2GoogleChartsModule,
    ChartsModule,
    ImageCropperModule,
  ],
  providers: [
    ApplicationService,
    AnalyticService,
    AuditService,
    UserService,
    DeviceService,
    GroupService,
    SocketService,
    ContentService,
    ActivationService,
    DistributionService,
    SyncService,
    SyncthingService,
    HttpInterceptor,
    RemoteConfigService,
    StructuredService,
  ],
})
export class SharedModule { }
